import React from "react";
import { Button, Collapse } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { styleBlock } from "../styleBlock";
import iconDropdownDownGray from "../assets/icons/Arrow Simple/Down.svg";
import iconDropdownUpGray from "../assets/icons/Arrow Simple/Up.svg";
export default class ProductRow extends React.Component {
    constructor(props) {
        super(props);
        const initialCollapseState = localStorage.getItem("product-row-" + props.id);
        this.state = { open: initialCollapseState !== null ? initialCollapseState === "true" : true };
    }
    toggleCollapse() {
        const newState = !this.state.open;
        this.setState({ open: newState });
        localStorage.setItem("product-row-" + this.props.id, newState.toString());
    }
    render() {
        const { actions, title, titleSuffix, titleDisabled, icon, collapsible, className, children, translateFunc } = this.props;
        const classNames = styleBlock("productrow");
        const cn = classNames({}).mix([className]);
        const buttonAlt = this.state.open ? "close" : "open";
        return (React.createElement(Row, { noGutters: true, className: "align-items-center " + cn.toString() },
            React.createElement(Col, { className: "d-flex align-items-center" + (titleDisabled ? " title-disabled" : "") },
                icon && (React.createElement("img", { className: "d-inline-block pr-2 pl-2 mt-n3 mr-1 content-size", width: "56", height: "56", src: icon, role: "presentation" })),
                React.createElement("h2", { className: "display-1 d-inline-block mb-0 font-weight-normal" },
                    title,
                    titleSuffix && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "d-none d-sm-inline" }, " - "),
                        " ",
                        React.createElement("br", { className: "d-inline d-sm-none" }),
                        titleSuffix)))),
            React.createElement(Col, { xs: "auto", className: "pr-3 pr-sm-2 ml-auto" },
                actions,
                collapsible && (React.createElement(Button, { onClick: () => this.toggleCollapse(), variant: "link", className: "ml-0 mt-n2 pr-0 pr-sm-2" },
                    React.createElement("img", { width: "16", height: "16", src: this.state.open ? iconDropdownUpGray : iconDropdownDownGray, alt: translateFunc(`drop_down_arrow.${buttonAlt}`) })))),
            collapsible ? (React.createElement(Collapse, { in: this.state.open },
                React.createElement(Col, { xs: 12 }, children))) : (children)));
    }
}
//# sourceMappingURL=index.js.map